import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}/alteracao-consultas-finalizadas`

    return {
        index() {
            return repository.get(`${baseUrl}`)
        },
        getUnidades(queryParms) {
            return repository.get(`${baseUrl}/unidade?${urlUtil.serialize(queryParms)}`)
        },
        getEspecialidades(queryParms) {
            return repository.get(`${baseUrl}/especialidade?${urlUtil.serialize(queryParms)}`)
        },
        getUsuarios(queryParms) {
            return repository.get(`${baseUrl}/usuario?${urlUtil.serialize(queryParms)}`)
        },
        list(queryParms) {
            return repository.get(`${baseUrl}/list?${urlUtil.serialize(queryParms)}`)
        },
        store(params) {
            return repository.post(`${baseUrl}`, params)
        }
    }
}